import { useState, useEffect, useCallback } from "react";
import { FaFileExcel, FaSearch } from 'react-icons/fa'; // Import icons
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import DataTable from 'react-data-table-component';
import 'jspdf-autotable'; // For table formatting in PDF
import '../common/style.css';
import './candidate.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { searchCandidateData } from "../http/api";
import Loading from "../loading/loading";
import * as XLSX from 'xlsx';
import { APP_BASE_URL } from "../http/global";
import { useAuth } from "../http/authcontex";

export default function ExportCandidateComponent() {

    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const authContext = useAuth();

    const exportToExcel = () => {
        const modifiedCandidates = filteredCandidates.map(candidate => ({
            'Aadhar Number': candidate.aadhar_number,
            'Candidate Name': candidate.candidate_name,
            'Project': candidate.project_name,
            'Job Role': candidate.jobrole_name,
            'TC Name': candidate.submitted_by,
            'Gender': candidate.gender,
            'Mobile': candidate.mobile,
            'Alternative Mobile': candidate.alternative_mobile,
            'Email': candidate.email,
            'Father Name': candidate.father_name,
            'Mother Name': candidate.mother_name,
            'Guardian Name': candidate.guardian_name,
            'Address': candidate.address,
            'State': candidate.state,
            'Pin Code': candidate.pin_code,
            'Bank Account Holder Name': candidate.bank_account_name,
            'Bank Name': candidate.bank_name,
            'Bank Account Number': candidate.bank_account_number,
            'IFSC': candidate.ifsc,
            'Marital Status': candidate.marital_status,
            'Date of Birth': candidate.date_of_birth,
            'Disability': candidate.disability,
            'Education': candidate.education,
            'Pre-Training Status': candidate.pre_training_status,
            'Year Of Experience': candidate.year_of_experience,
            'Religion': candidate.religion,
            'Cast Category': candidate.cast_category,

            'Candidate Photo': candidate.candidate_photo ? {
                t: 's',
                v: 'Click here to view',
                l: { Target: `${APP_BASE_URL}/displayimage?keyName=${encodeURIComponent(candidate.candidate_photo)}` },
                s: { font: { color: { rgb: "0000FF" }, underline: true } } // Highlighting the link
            } : '',

            'Front Aadhar Photo': candidate.front_aadhar_photo ? {
                t: 's',
                v: 'Click here to view',
                l: { Target: `${APP_BASE_URL}/displayimage?keyName=${encodeURIComponent(candidate.front_aadhar_photo)}` },
                s: { font: { color: { rgb: "0000FF" }, underline: true } } // Highlighting the link
            } : '',

            'Back Aadhar Photo': candidate.back_aadhar_photo ? {
                t: 's',
                v: 'Click here to view',
                l: { Target: `${APP_BASE_URL}/displayimage?keyName=${encodeURIComponent(candidate.back_aadhar_photo)}` },
                s: { font: { color: { rgb: "0000FF" }, underline: true } } // Highlighting the link
            } : '',

            'Bank Photo': candidate.bank_photo ? {
                t: 's',
                v: 'Click here to view',
                l: { Target: `${APP_BASE_URL}/displayimage?keyName=${encodeURIComponent(candidate.bank_photo)}` },
                s: { font: { color: { rgb: "0000FF" }, underline: true } } // Highlighting the link
            } : '',

            'Education Photo': candidate.education_photo ? {
                t: 's',
                v: 'Click here to view',
                l: { Target: `${APP_BASE_URL}/displayimage?keyName=${encodeURIComponent(candidate.education_photo)}` },
                s: { font: { color: { rgb: "0000FF" }, underline: true } } // Highlighting the link
            } : '',

            'Cast Photo': candidate.cast_photo ? {
                t: 's',
                v: 'Click here to view',
                l: { Target: `${APP_BASE_URL}/displayimage?keyName=${encodeURIComponent(candidate.cast_photo)}` },
                s: { font: { color: { rgb: "0000FF" }, underline: true } } // Highlighting the link
            } : '',
        }));

        const worksheet = XLSX.utils.json_to_sheet(modifiedCandidates, { cellDates: true });

        worksheet['!cols'] = [
            { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 },
            { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 },
            { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Candidates");

        const currentDateTime = new Date().toISOString().replace(/[-:]/g, '').replace(/\..+/, '');
        const fileName = `candidates_${currentDateTime}.xlsx`;

        XLSX.writeFile(workbook, fileName);
    };

    const handleOpenNewTab = (keyName) => {
        const newTabUrl = `/displayimage?keyName=${encodeURIComponent(keyName)}`;
        // Open a new tab
        window.open(newTabUrl, '_blank');
    };

    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem('sb|sidebar-toggle') === 'true'
    );

    useEffect(() => {
        localStorage.setItem('sb|sidebar-toggle', isSidebarOpen);
    }, [isSidebarOpen]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        localStorage.setItem('sb|sidebar-toggle', !isSidebarOpen);
    };

    const [candidates, setCandidates] = useState([

    ]);

    const [searchTerm, setSearchTerm] = useState("");
    const [filteredCandidates, setFilteredCandidates] = useState(candidates);

    useEffect(() => {
        const filtered = candidates.filter(candidate =>
            Object.values(candidate).some(value =>
                typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setFilteredCandidates(filtered);
    }, [searchTerm, candidates]);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');


    const viewCandidateData = useCallback((startDate, endDate) => {
        setLoading(true);
        searchCandidateData(startDate, endDate)
            .then(response => {
                if (response.status === 200) {
                    const candidatesData = response.data.map(item => ({
                        aadhar_number: item.candidate.aadharNumber,
                        address: item.candidate.address,
                        back_aadhar_photo: item.candidate.backAadharPhoto,
                        bank_account_name: item.candidate.bankAccountName,
                        bank_account_number: item.candidate.bankAccountNumber,
                        bank_name: item.candidate.bankName,
                        candidate_name: item.candidate.candidateName,
                        candidate_photo: item.candidate.candidatePhoto,
                        cast_category: item.candidate.castCategory,
                        created_date: item.candidate.createdDate,
                        date_of_birth: item.candidate.dateOfBirth,
                        disability: item.candidate.disability,
                        education: item.candidate.education,
                        email: item.candidate.email,
                        father_name: item.candidate.fatherName,
                        front_aadhar_photo: item.candidate.frontAadharPhoto,
                        gender: item.candidate.gender,
                        guardian_name: item.candidate.guardianName,
                        ifsc: item.candidate.ifsc,
                        last_modified_date: item.candidate.lastModifiedDate,
                        marital_status: item.candidate.maritalStatus,
                        mobile: item.candidate.mobile,
                        alternative_mobile: item.candidate.alternativeMobile,
                        mother_name: item.candidate.motherName,
                        pin_code: item.candidate.pinCode,
                        pre_training_status: item.candidate.preTrainingStatus,
                        year_of_experience: item.candidate.yearofExperience,
                        religion: item.candidate.religion,
                        state: item.candidate.state,
                        submitted_by: item.candidate.submittedBy,
                        bank_photo: item.candidate.bankPhoto,
                        cast_photo: item.candidate.castPhoto,
                        education_photo: item.candidate.educationPhoto,
                        project_name: item.project,
                        jobrole_name: item.jobrole,
                    }));

                    setCandidates(candidatesData);
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // If 401 Unauthorized, redirect to login
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    // Handle other errors
                    console.error('Error fetching dashboard details:', error);
                }
            });
    }, [authContext, navigate]);

    useEffect(() => {
        if (startDate && endDate) {

            viewCandidateData(startDate, endDate)
        }
    }, [startDate, endDate, viewCandidateData]);

    const columns = [
        {
            name: 'TC Name',
            selector: row => row.submitted_by,
            sortable: true,
        },
        {
            name: 'Project',
            selector: row => row.project_name,
            sortable: true,
        },
        {
            name: 'Job role',
            selector: row => row.jobrole_name,
            sortable: true,
        },
        {
            name: 'Aadhar Number',
            selector: row => row.aadhar_number,
            sortable: true,
        },
        {
            name: 'Candidate Name',
            selector: row => row.candidate_name,
            sortable: true,
        },
        {
            name: 'Candidate Photo',
            selector: row => row.candidate_photo ? (
                <button
                    onClick={() => handleOpenNewTab(row.candidate_photo)}
                    style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                >
                    Click here to view
                </button>
            ) : 'N/A', // Display 'N/A' if no photo URL
            sortable: true,
        },
        {
            name: 'Gender',
            selector: row => row.gender,
            sortable: true,
        },
        {
            name: 'Mobile',
            selector: row => row.mobile,
            sortable: true,
        },
        {
            name: 'Alternative Mobile',
            selector: row => row.alternative_mobile,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Front Aadhar Photo',
            selector: row => row.front_aadhar_photo ? (
                <button
                    onClick={() => handleOpenNewTab(row.front_aadhar_photo)}
                    style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                >
                    Click here to view
                </button>
            ) : 'N/A', // Display 'N/A' if no photo URL
            sortable: true,
        },
        {
            name: 'Back Aadhar Photo',
            selector: row => row.back_aadhar_photo ? (
                <button
                    onClick={() => handleOpenNewTab(row.back_aadhar_photo)}
                    style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                >
                    Click here to view
                </button>
            ) : 'N/A', // Display 'N/A' if no photo URL
            sortable: true,
        },
        {
            name: 'Marital Status',
            selector: row => row.marital_status,
            sortable: true,
        },
        {
            name: 'Father Name',
            selector: row => row.father_name,
            sortable: true,
        },
        {
            name: 'Mother Name',
            selector: row => row.mother_name,
            sortable: true,
        },
        {
            name: 'Guardian Name',
            selector: row => row.guardian_name,
            sortable: true,
        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: true,
        },
        {
            name: 'Address',
            selector: row => row.address,
            sortable: true,
        },
        {
            name: 'Pin Code',
            selector: row => row.pin_code,
            sortable: true,
        },
        {
            name: 'Bank Account Name',
            selector: row => row.bank_account_name,
            sortable: true,
        },
        {
            name: 'Bank Name',
            selector: row => row.bank_name,
            sortable: true,
        },
        {
            name: 'Bank Account Number',
            selector: row => row.bank_account_number,
            sortable: true,
        },
        {
            name: 'IFSC',
            selector: row => row.ifsc,
            sortable: true,
        },
        {
            name: 'Bank Photo',
            selector: row => row.bank_photo ? (
                <button
                    onClick={() => handleOpenNewTab(row.bank_photo)}
                    style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                >
                    Click here to view
                </button>
            ) : 'N/A', // Display 'N/A' if no photo URL
            sortable: true,
        },
        {
            name: 'Date of Birth',
            selector: row => row.date_of_birth,
            sortable: true,
        },
        {
            name: 'Disability',
            selector: row => row.disability,
            sortable: true,
        },
        {
            name: 'Education',
            selector: row => row.education,
            sortable: true,
        },
        {
            name: 'Education Photo',
            selector: row => row.education_photo ? (
                <button
                    onClick={() => handleOpenNewTab(row.education_photo)}
                    style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                >
                    Click here to view
                </button>
            ) : 'N/A', // Display 'N/A' if no photo URL
            sortable: true,
        },
        {
            name: 'Pre-Training Status',
            selector: row => row.pre_training_status,
            sortable: true,
        },
        {
            name: 'Year Of Experience',
            selector: row => row.year_of_experience,
            sortable: true,
        },
        {
            name: 'Religion',
            selector: row => row.religion,
            sortable: true,
        },
        {
            name: 'Cast Category',
            selector: row => row.cast_category,
            sortable: true,
        },
        {
            name: 'Cast Photo',
            selector: row => row.cast_photo ? (
                <button
                    onClick={() => handleOpenNewTab(row.cast_photo)}
                    style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                >
                    Click here to view
                </button>
            ) : 'N/A', // Display 'N/A' if no photo URL
            sortable: true,
        }
    ];

    return (
        <div className="ExportCandidateComponent">
            {loading && <Loading />}
            <div className={`sb-nav-fixed ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
                <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                <div id="layoutSidenav">
                    <SideNave isSidebarOpen={isSidebarOpen} />
                    <div id="layoutSidenav_content">
                        <main>
                            <div className="container-fluid px-4">
                                <h4 className="mt-4">Export Candidate</h4>

                                {/* Export buttons */}
                                <div className="mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <button
                                                onClick={exportToExcel}
                                                className="btn btn-sm btn-success me-2"
                                            >

                                                <FaFileExcel /> Export to Excel
                                            </button>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="text"
                                                placeholder="Search..."
                                                className="form-control me-2"
                                                value={searchTerm}
                                                onChange={e => setSearchTerm(e.target.value)}
                                            />
                                            <button className="btn btn-sm btn-secondary">
                                                <FaSearch />
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="card mb-4">
                                    <div className="card-header">
                                        <i className="fas fa-table me-1"></i>
                                        Candidate Details
                                    </div>
                                    <div className="card-body shadow-sm border-0">
                                        <DataTable
                                            className="data-table"
                                            columns={columns}
                                            data={filteredCandidates}
                                            pagination
                                            highlightOnHover

                                        />
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </div>
    );
}
